// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { AVAILABILITY_CHECK_FUNCTIONS } from './../../../types/next/blocks/availabilityCheckBlock'
import {
  addressValueSchema,
  geoAddressValueSchema,
  unlistedAddressValueSchema
} from './addresses.zod'
import { blockBaseSettingsSchema, iBlockSchema } from './baseBlock.zod'
import { referenceIdSchema } from './ids.zod'
import { blockReferenceSchema } from './references.zod'

export const availabilityCheckFunctionsSchema = z.nativeEnum(
  AVAILABILITY_CHECK_FUNCTIONS
)

export const availabilityProductBlockReferenceSchema =
  blockReferenceSchema.extend({
    meaning: z.literal('products')
  })

export const availabilityBlockValueSchema = addressValueSchema
  .extend(geoAddressValueSchema.shape)
  .extend(unlistedAddressValueSchema.shape)
  .extend({
    suburb: z.string().optional().nullable(),
    streetName: z.string().optional().nullable(),
    streetNumber: z.string().optional().nullable()
  })

const availabilityCheckControlOptionsSchema = z.any()

export const availabilityCheckBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.AVAILABILITY_CHECK),
  settings: blockBaseSettingsSchema.and(availabilityCheckControlOptionsSchema),
  references: z.record(
    referenceIdSchema,
    availabilityProductBlockReferenceSchema
  )
})
